import * as types from './types';
import { log } from '../../../utils/jsUtils';
import SPBackend from '../../../services/SPBackend';
import { setIsAppLoading, setLoadingModule } from '../common';

export const setAnalyticsData = (data) => ({
  type: types.SET_ANALYTICS_DATA,
  payload: data
});

export const setAnalyticsTimeRange = (timeRange) => ({
  type: types.SET_ANALYTICS_TIME_RANGE,
  payload: timeRange
});

export const setAnalyticsFilters = (filters) => ({
  type: types.SET_ANALYTICS_FILTERS,
  payload: filters
});

export const setAnalyticsLoading = (isLoading) => ({
  type: types.SET_ANALYTICS_LOADING,
  payload: isLoading
});

export const fetchAnalyticsData = (user, timeRange, filters) => async (dispatch) => {
  try {
    dispatch(setAnalyticsLoading(true));
    dispatch(setLoadingModule('analytics', true));
    
    const response = await SPBackend.getAnalyticsData(user, timeRange, filters);
    dispatch(setAnalyticsData(response.data));
    
    return response.data;
  } catch (error) {
    log('[fetchAnalyticsData] error:', error);
    return null;
  } finally {
    dispatch(setAnalyticsLoading(false));
    dispatch(setLoadingModule('analytics', false));
  }
}; 